import React, { useState } from "react";
import { X, Tag, Plus, Minus } from "lucide-react";
import { assignItemFlags, removeItemFlags } from "../../services/catalogService";

const ItemFlagsEditor = ({ selectedIds, flagDefinitions, onClose, onDone }) => {
    const [flagId, setFlagId] = useState(flagDefinitions[0]?.id || "");
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    const apply = async (mode) => {
        if (!flagId) return;
        setSaving(true);
        setError("");
        try {
            if (mode === "add") await assignItemFlags(selectedIds, flagId);
            else await removeItemFlags(selectedIds, flagId);
            onDone();
        } catch (e) {
            setError(e.message || "Failed to update flags");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden">
                <div className="bg-gradient-to-r from-teal-500 to-blue-600 px-6 py-4 flex items-center justify-between">
                    <h2 className="text-white font-bold text-lg flex items-center gap-2"><Tag size={18} /> Set Flags</h2>
                    <button onClick={onClose} className="text-white/70 hover:text-white"><X size={20} /></button>
                </div>
                <div className="p-6">
                    <p className="text-xs text-gray-400 mb-4">
                        Applying to <strong>{selectedIds.length}</strong> selected product{selectedIds.length !== 1 && "s"}.
                    </p>

                    {flagDefinitions.length === 0 ? (
                        <p className="text-sm text-gray-400 mb-4">No flags yet — create one first in Settings → Flags.</p>
                    ) : (
                        <select value={flagId} onChange={(e) => setFlagId(e.target.value)}
                            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm mb-4 focus:outline-none focus:border-teal-500">
                            {flagDefinitions.map((f) => <option key={f.id} value={f.id}>{f.name}</option>)}
                        </select>
                    )}

                    {error && <p className="text-red-500 text-xs mb-3">{error}</p>}

                    <div className="flex gap-2">
                        <button onClick={() => apply("add")} disabled={saving || !flagId}
                            className="flex-1 py-3 bg-gradient-to-r from-teal-500 to-blue-600 text-white rounded-xl font-bold hover:opacity-90 transition disabled:opacity-50 flex items-center justify-center gap-1">
                            <Plus size={15} /> Add
                        </button>
                        <button onClick={() => apply("remove")} disabled={saving || !flagId}
                            className="flex-1 py-3 bg-gray-100 text-gray-600 rounded-xl font-bold hover:bg-gray-200 transition disabled:opacity-50 flex items-center justify-center gap-1">
                            <Minus size={15} /> Remove
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ItemFlagsEditor;